import { AddedRolesTable } from './added-roles';
import { AvailableRolesTable } from './available-roles';
import { SelectedRole } from './types';

type RolesFormListProps = {
  selectedRoles: SelectedRole[];
  onChange: React.Dispatch<React.SetStateAction<SelectedRole[]>>;
};

export const RolesFormList = ({
  selectedRoles,
  onChange,
}: RolesFormListProps) => {
  const onAdd = (role: SelectedRole) => {
    onChange((items) => [...items, role]);
  };

  const onDelete = (id: string) => {
    onChange((items) => items.filter((item) => item.id !== id));
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
      <AvailableRolesTable
        selectedItems={selectedRoles}
        onChange={onAdd}
        withLinks
      />
      <AddedRolesTable roles={selectedRoles} onChange={onDelete} withLinks />
    </div>
  );
};
